<template>
<div id="app">
    <Navbar></Navbar>
    <Content></Content>
    <Footer></Footer>
</div>
</template>

<script>
import Navbar from '@/components/templates/NavbarSshi2023.vue'
import Content from '@/components/templates/Content.vue'
import Footer from '@/components/templates/Footer.vue'
export default {
    name: 'SshiLayoutBaru',
    components: {
        Navbar,
        Content,
        Footer
    },
}
</script>
